"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Beef, Flame, ShieldCheck, Utensils } from "lucide-react";
export default function LocallySourcedDailySmashed() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const benefits = [{
    icon: Beef,
    title: "IL MIO ZAINO",
    description: "Cosa metto nello zaino",
    titleClassName: "mt-1 bg-accent/30 p-3 rounded-full text-primary border border-border/30 group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-500 shadow-sm !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648136/img/ioconzainodadietro.png)]"
  }, {
    icon: Flame,
    title: "Il Suono del Metallo",
    description: "Vibrazioni che risuonano tra le trincee e le vette del Vicentino."
  }, {
    icon: ShieldCheck,
    title: "Onore ai Caduti",
    description: "Ogni nota è un tributo silenzioso a chi ha combattuto quassù."
  }];
  return <section data-section-id="223914" id="il-cammino-e-la-musica" className="bg-background text-foreground relative w-full flex flex-col md:flex-row border-y border-border/50">
      {}
      <div className="w-full md:w-1/2 h-[50vh] md:h-screen md:sticky top-0 relative overflow-hidden bg-muted flex-shrink-0 border-b md:border-b-0 md:border-r border-border/50">
        {}
        <div className="absolute inset-0 !bg-[url(https://sacropan.it/wp-content/uploads/2026/04/20230204_162708-scaled.jpg)] bg-cover bg-center grayscale contrast-110 opacity-40" />
        
        {}
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/10 to-transparent md:hidden" />

        {}
        <div className="absolute top-6 left-6 md:top-12 md:left-12 w-32 h-32 md:w-48 md:h-48 animate-[spin_25s_linear_infinite] z-10">
          <svg viewBox="0 0 100 100" className="w-full h-full fill-primary drop-shadow-lg">
            <path id="circlePath" d="M 50, 50 m -37, 0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0" fill="none" />
            <text className="text-[10px] font-medium uppercase tracking-[0.3em] font-serif">
              <textPath href="#circlePath" startOffset="0%">
                • IL CAMMINO • LA MUSICA • IL RICORDO
              </textPath>
            </text>
          </svg>
        </div>
      </div>

      {}
      <div className="w-full md:w-1/2 relative min-h-[120vh] flex flex-col justify-start items-center px-6 py-24 md:px-12 lg:px-24 z-10 overflow-hidden">
        
        {}
        <div className="absolute right-4 top-1/3 text-primary/5 animate-[bounce_12s_ease-in-out_infinite] pointer-events-none -rotate-12">
          <Utensils size={240} strokeWidth={0.3} />
        </div>

        <div ref={contentRef} className={`relative z-10 max-w-xl mx-auto mt-12 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-16"}`}>
          {}
          <div className="mb-12">
            
            
          </div>

          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed mb-12 font-serif italic text-center">
            Portare il suono dove il silenzio è diventato eterno. Tra le rocce del Pasubio e dell'Altopiano, il mio handpan diventa voce per chi non può più parlare.
          </p>

          {}
          <ul className="space-y-8 mb-12">
            {benefits.map((benefit, i) => {
            const content = <li key={i} data-index={i} className={`flex items-start gap-5 group ${i === 0 ? "cursor-pointer hover:opacity-80 transition-opacity" : ""}`}>
                  <div className={`${benefit.titleClassName || ""} mt-1 bg-accent/30 p-3 rounded-full text-primary border border-border/30 group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-500 shadow-sm`}>
                    <benefit.icon size={24} strokeWidth={1.5} />
                  </div>
                  <div>
                    <h3 className="font-default font-semibold text-xl text-foreground uppercase tracking-tight mb-1">
                      {benefit.title}
                    </h3>
                    <p className="text-muted-foreground leading-snug font-serif">
                      {benefit.description}
                    </p>
                  </div>
                </li>;
            return i === 0 ? <Link key={i} to="#">{content}</Link> : content;
          })}
          </ul>

          {}
          <div className="pt-6 border-t border-border/20">
            <Button size="lg" asChild className="w-full sm:w-auto h-14 px-8 text-lg font-medium uppercase tracking-widest shadow-md hover:shadow-primary/10 hover:-translate-y-1 transition-all duration-500 bg-primary text-primary-foreground rounded-none">
              <Link to="#">ESCURSIONI E MAPPE</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}